import { render, staticRenderFns } from "./PreviewJobContentOrientsForSp.vue?vue&type=template&id=1fa44da6&scoped=true"
import script from "./PreviewJobContentOrientsForSp.vue?vue&type=script&lang=js"
export * from "./PreviewJobContentOrientsForSp.vue?vue&type=script&lang=js"
import style0 from "./PreviewJobContentOrientsForSp.vue?vue&type=style&index=0&id=1fa44da6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa44da6",
  null
  
)

export default component.exports